(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["uls-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          var swiper = new Swiper(".product-recommendations .alsolikeSwiper", {
            observer: true,
            observeParents: true,
            navigation: {
            nextEl: ".alsolikeSwiper .swiper-button-next",
            prevEl: ".alsolikeSwiper .swiper-button-prev",
            },
            breakpoints: {
                320: { //当屏幕宽度大于等于320
                slidesPerView: 1.3,
                spaceBetween: 12
                },
                768: { //当屏幕宽度大于等于768
                slidesPerView: 3.2,
                spaceBetween: 16
                },
                1280: { //当屏幕宽度大于等于1280
                slidesPerView: 3.3,
                spaceBetween: 16
                }
            }
          });
             
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
